import React, { createContext, useState, useEffect, useContext } from "react";
import api from "../utils/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUserData = async () => {
    try {
      const response = await api.get("crm/user");
      console.log("---- Full Axios Response Object ----", response);

      if (response.status === 200) {
        const result = response.data;

        if (result.code === "0" && result.data) {
          const u = result.data;
          setUser({
            id: u.id,
            name: u.name,
            username: u.username,
            role: u.authorities?.[0]?.authority ?? null,
            // deliberately not storing `password` — no reason for the hash to live client-side
          });
          return true; // Success
        }
      } else if (response.status === 401) {
        logout();
      }
    } catch (error) {
      console.error("Error fetching global context user data:", error);
    }

    setUser(null);
    return false;
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("tokenExpiry");
    setUser(null);
    window.location.href = "/login";
  };

  useEffect(() => {
    const initializeAuth = async () => {
      await fetchUserData();
      setLoading(false);
    };
    initializeAuth();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        userId: user?.id ?? null,
        userName: user?.name ?? "",
        setUser,
        loading,
        fetchUserData,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}